import React from 'react';
import { Badge, Box, Flex, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconCheck, IconClock, IconLock } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Eyebrow } from './primitives';
import { SummaryStageBlock } from './types';

interface SummaryBodyProps {
  blocks: SummaryStageBlock[];
}

export const SummaryBody: React.FC<SummaryBodyProps> = ({ blocks }) => {
  const { t } = useTranslation();
  const ready = blocks.filter((b) => b.ready).length;
  return (
    <Paper withBorder p="xl" radius="md">
      <Flex justify="space-between" align="flex-end" mb="lg">
        <Box>
          <Eyebrow>{t('perfReview.home.summaryStage.section')}</Eyebrow>
          <Title order={3} size="h4" mt={6} style={{ letterSpacing: '-0.01em' }}>
            {t('perfReview.home.summaryStage.title')}
          </Title>
        </Box>
        <Badge variant="default" size="sm" leftSection={<IconLock size={12} />}>
          {t('perfReview.home.summaryStage.draftHidden')}
        </Badge>
      </Flex>
      <Stack gap={10}>
        {blocks.map((b) => (
          <Paper
            key={b.id}
            p="sm"
            radius="md"
            withBorder
            style={{
              background: 'var(--mantine-color-default-hover)',
              display: 'grid',
              gridTemplateColumns: '32px 1fr auto',
              gap: 16,
              alignItems: 'center',
            }}
          >
            {b.ready ? (
              <ThemeIcon size={28} radius="md" color="teal" variant="filled">
                <IconCheck size={14} />
              </ThemeIcon>
            ) : (
              <ThemeIcon size={28} radius="md" color="gray" variant="default">
                <IconClock size={14} />
              </ThemeIcon>
            )}
            <Box>
              <Text size="sm" fw={500}>
                {b.title}
              </Text>
              <Text size="xs" c="dimmed" mt={2}>
                {b.ready
                  ? t('perfReview.home.summaryStage.blockReady')
                  : t('perfReview.home.summaryStage.blockPending')}
              </Text>
            </Box>
            <Text size="xs" c="dimmed" style={{ fontVariantNumeric: 'tabular-nums' }}>
              {b.ready ? `${ready}/${blocks.length}` : '—'}
            </Text>
          </Paper>
        ))}
      </Stack>
    </Paper>
  );
};
